import { createAsyncThunk } from '@reduxjs/toolkit';

import { fetchPlayerConfigSync, type FetchPlayerConfigSyncParams } from '../../api/fetchers/playerConfigSync/fetcher';

interface FetchPlayerConfigSyncActionParams extends FetchPlayerConfigSyncParams {
  essential?: boolean;
}

export const fetchPlayerConfigSyncAction = createAsyncThunk(
  'playerConfig/fetchPlayerConfigSync',
  (params: FetchPlayerConfigSyncActionParams) => fetchPlayerConfigSync(params)
);
